import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import useFlowState from '#client/hooks/flow/useFlowState';

function ContactInfoSummary() {
  const { contactInfo } = useFlowState();

  const { email, phone, firstName, lastName } = contactInfo;
  const fullName = `${firstName} ${lastName}`;

  return (
    <Stack spacing={0.5}>
      <Heading component="h3" size="sm" weight="medium">
        <FormattedMessage id="shopping.page.checkout.business.accountOwner" />
      </Heading>
      <Text size="xs">{fullName}</Text>
      <Text size="xs">{email}</Text>
      <Text size="xs">{phone}</Text>
    </Stack>
  );
}

export default ContactInfoSummary;
